// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md style="margin-bottom:100px;">
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'users'"
        editRoute="userEdit"
        :headers="headers"
        name="User"
        permissions="users"
        search
        extendedFab
        extendedFabText="New User"
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'
import {ENDPOINT} from '@/shared/constants'
import {getUserRolesText} from '@sdgsystems/vue-common/components/utils'

export default {
  components: {
    ItemList
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Username',
          value: 'username',
          sortable: true
        },
        {
          text: 'Roles',
          value: 'roles',
          function: this.rolesToText,
          context: ENDPOINT + 'roles',
          sortable: true
        }
      ]
    }
  },

  methods: {
    rolesToText: function (user, roles) {
      return getUserRolesText(user.roles, roles)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Users.vue?2568eff8